import { render, staticRenderFns } from "./DocumentOrderGrid.vue?vue&type=template&id=f7db3b96"
import script from "./DocumentOrderGrid.vue?vue&type=script&lang=js"
export * from "./DocumentOrderGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports